import { Column } from 'src/shared/components/Semantic/all'
import { Loader } from 'lucide-react'

export const LoadingState = () => {
  return (
    <Column className="w-full h-dvh items-center justify-center gap-4">
      <Loader className="w-8 h-8 animate-spin text-gray-600" />
      <p>Loading...</p>
    </Column>
  )
}

